<template>
  <van-overlay
    :show="show"
    class-name="last-device-overlay"
    :z-index="1000"
    @click="onClose"
    >
    <div class="device-wrapper">
      <div class="device-container">
        <img src="@/assets/image/device/close.png" alt="" class="close-icon">
        <p class="title">
          发现设备：
        </p>
        <p class="name">
          {{ lastConnectDevice.name }}
        </p>
        <div class="device-default">
          <img src="@/assets/image/device/printer.png" alt="" />
        </div>

        <div class="connect-btn">
          <van-button
            @click.stop="connect"
          >连接设备</van-button>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { Overlay } from 'vant';
import { deviceLocalKey } from '@/config/index';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'LastDevice',
  components: {
    [Overlay.name] : Overlay
  },
  data() {
    return {
      show: false,
      lastConnectDevice: {},
      timer: null,
      connectLoading: null,
      duration: 30, // 单位：秒
    }
  },
  // watch: {
  //   $route: {
  //     deep: true,
  //     handler(newValue) {
  //       const {
  //         path
  //       } = newValue

  //       if (path.startsWith('/device')) {
  //         this.stopSearch()
  //       }
  //     }
  //   }
  // },
  computed: {
    ...mapGetters([ 'device' ])
  },
  methods: {
    ...mapActions(['setDevice']),
    connect() {
      // this.connectDevice(this.lastConnectDevice)
      // 由于权限检测改到了device页面获取，所以有可能在其他页面时没有初始化蓝牙功能，所以连接上次的设备功能调整为跳转到设备页
      this.onClose()
      this.$router.push('/device')
    },
    onClose() {
      this.show = false
      this.stopSearch()
    },
    stopBluetoothSearch() {
      const config = {
        event: 'stopSearchBluetooth'
      }

      this.$utils.app.sendAppMsg(config)
    },
    getLastConnectDevice() {
      const localDevice = localStorage.getItem(deviceLocalKey)
      if (localDevice) {
        try {
          const lastConnectDevice = JSON.parse(localDevice)

          if (lastConnectDevice && !this.device.address) {
            this.lastConnectDevice = lastConnectDevice

            this.requestDevices()
            // 只搜索指定时长，超时则自动停止
            this.timer = this.timer || setTimeout(() => {
              this.stopSearch()
            }, this.duration * 1000)
          }
        } catch {
          console.error('解析记录设备信息出错')
        }
      }
    },
    stopSearch() {
      this.stopBluetoothSearch()
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    requestDevices() {
      const config = {
        event: 'openBluetooth',
        params: {},
        callback: this.getDevices
      }

      this.$utils.app.sendAppMsg(config)
    },
    getDevices(data) {
      const {
        device
      } = data
      
      const {
        address
      } = this.lastConnectDevice
      if (device.address === address) {
        this.lastConnectDevice = {
          name: device.name,
          address
        }

        this.show = true
        this.stopSearch()
      }
    },
    async connectDevice(device) {
      const versionStatus = this.$utils.app.limitVersion('1.0.6')
      if (!versionStatus) return
      
      const validate = await this.$utils.device.validatePrinter(device)
      if (!validate) {
        this.$Toast.fail('该设备未绑定到当前用户，请激活后重试')

        return
      }

      const { code: lastConnectStatus, info } = await this.$utils.device.getLastConnectInfo(device)
      if (lastConnectStatus === 2) {
        return
      } else if (lastConnectStatus === 1 && info.device_id) {
        const { created_name, device_brand, device_model } = info
        const confirmed = await this.$utils.confirm({
          title: `打印机已被${created_name}（${device_brand}-${device_model}）连接，是否继续连接？`
        })

        if (!confirmed) return
      }

      const config = {
        event: 'connectDevice',
        params: { device },
        callback: this.connectResult
      }

      this.$utils.app.sendAppMsg(config)
      this.connectLoading = this.$Toast.loading({
        forbidClick: true,
        message: '连接中...'
      })
    },
    connectResult(data) {
      if (this.connectLoading) {
        this.connectLoading.clear()
        this.connectLoading = null
      }
      
      const {
        status,
        device
      } = data
      if (status === 'connectSuccess') {
        this.$Toast.success('连接成功')
        localStorage.setItem(deviceLocalKey, JSON.stringify(device))
        this.setDevice(device)
        this.$utils.device.saveDeviceConnectInfo(device)
      } else if (status === 'connectFail') {
        this.$Toast.fail('连接失败')
      }

      this.show = false
    },

  },
  created() {
    this.$utils.jsBridgeReady()
    .then(ready => {
      if (ready) {
        this.getLastConnectDevice()
      }
    })
  }
}
</script>

<style lang="less">
  // 当前style标签没有scoped限制，其中的选择器需要注意避免冲突。
  .last-device-overlay {
    .device-wrapper {
      padding: 56px 64px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .device-container {
        background-color: rgba(254, 254, 254, 1);
        border-radius: 50px;
        height: 786px;
        width: 100%;
        position: relative;
        .close-icon {
          width: 54px;
          height: 54px;
          position: absolute;
          right: 54px;
          top: 62px;
        }
        .title {
          color: @font-black-2;
          font-size: 60px;
          font-weight: 600;
          margin: 104px 0 0;
          text-align: center;
        }
        .name {
          color: @font-black-2;
          font-size: 36px;
          margin: 32px 0 0;
          text-align: center;
        }
        .device-default {
          margin: 66px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 248px;
            height: 230px;
          }
        }
        .connect-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          .van-button {
            border-radius: 50px;
            border: none;
            background-color: @primary-color-1;
            color: #fff;
            font-size: 48px;
            font-weight: 600;
            width: 410px;
            height: 104px;
          }
        }
      }
    }
  }
</style>